import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {setupRem} from './assets/js/rem'
import toast from './assets/js/useToast'
import './assets/iconfont/iconfont.css'
import './assets/css/common.sass'
import { List,PullRefresh } from 'vant';
import 'vant/lib/index.css';

const app = createApp(App)
app.config.globalProperties.$toast = toast
app.use(List);
app.use(PullRefresh);
setupRem();
app.use(store).use(router).mount('#app')
// 类型声明
declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $toast: typeof toast
    }
}
